module.exports = __webpack_public_path__ + "static/img/home2.66be89b1.png";